import React from 'react';
import { bdnQuantityNote } from '../../utils/bdnQuantityNote';

// The line under a supplier invoice line's quantity that says where it stands
// against the delivery's BDN (ledger 166). The words come from
// utils/bdnQuantityNote.js. Inline colours, like the rest of the supplier
// invoice line table: green when the line is the BDN's, amber otherwise.
const TONE = { ok: '#047857', warn: '#b45309' };

const BdnQuantityNote = ({ quantity, bdnCheck, unit }) => {
  const note = bdnQuantityNote(quantity, bdnCheck, unit);
  if (!note) return null;
  const style = {
    fontSize: '10px', lineHeight: 1.3, marginTop: '2px', whiteSpace: 'normal', color: TONE[note.tone],
  };
  return (
    <div style={style} data-testid="bdn-quantity-note" data-tone={note.tone} role="note">
      {note.text}
    </div>
  );
};

export default BdnQuantityNote;
